import { createContext, useState, useEffect, useContext } from 'react';

import { urlHasParameter } from '@lib/helpers';

const ParamCheckContext = createContext();

export const ParamCheckProvider = ({ children }) => {
	const [hideMasthead, setHideMasthead] = useState(false);
	const [previewProspectus, setPreviewProspectus] = useState(false);

	useEffect(() => {
		if (urlHasParameter('hide_masthead')) {
			setHideMasthead(true);
		}
		if (urlHasParameter('previewProspectus')) {
			setPreviewProspectus(true);
		}
	}, []);

	return (
		<ParamCheckContext.Provider
			value={{
				hideMasthead,
				previewProspectus,
			}}
		>
			{children}
		</ParamCheckContext.Provider>
	);
};

export function useParamCheck() {
	const context = useContext(ParamCheckContext);
	return context;
}
